import { Component, inject, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarComponent } from '@vendasta/galaxy/avatar';
import { VENDASTA_AI_AVATAR_SVG_ICON } from '@galaxy/ai-assistant';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { InboxAiSupportBannerBackgroundComponent } from './inbox-ai-support-banner-background/inbox-ai-support-banner-background.component';
import { ViewModeService } from '../../../../core/src/lib/view-mode.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'inbox-ai-support-banner',
  imports: [
    CommonModule,
    AvatarComponent,
    MatButton,
    TranslateModule,
    MatIcon,
    InboxAiSupportBannerBackgroundComponent,
  ],
  templateUrl: './inbox-ai-support-banner.component.html',
  styleUrl: './inbox-ai-support-banner.component.scss',
})
export class InboxAiSupportBannerComponent {
  protected readonly VENDASTA_AI_AVATAR_SVG_ICON = VENDASTA_AI_AVATAR_SVG_ICON;
  protected readonly viewModeService = inject(ViewModeService);
  protected readonly avatarBorderColor = '#FFFFFF';
  protected readonly avatarWidth = 50;
  chatWithAiButtonClicked = output<void>();

  openInboxAI(): void {
    this.chatWithAiButtonClicked.emit();
  }
}
